<div class="root-body" style="padding: 0"
     [ngClass]="{
    'root-body-sidebar-slim': configService.config.menuMode === 'sidebar' || configService.config.menuMode === 'slim',
    'root-body-sidebar-static': configService.config.menuMode === 'sidebar' && configService.config.sidebarStatic,
    'root-body-horizontal': configService.config.menuMode === 'horizontal'}">

    <p-toast position="top-right"></p-toast>

    <div class="card">
        <!-- Table -->
        <p-table [columns]="this.selectedColumns"
                 [value]="companyTransactions"
                 [lazy]="true"
                 responsiveLayout="auto"
                 selectionMode="single"
                 dataKey="Id"
                 (onLazyLoad)="handleLazyLoad($event)"
                 [selection]="selectedTransaction"
                 (selectionChange)="onSelectionChange($event)"
                 [paginator]="true"
                 [(first)]="first"
                 [rows]="rowsPerPage"
                 [showFirstLastIcon]="false"
                 [totalRecords]="totalRecords"
                 [resizableColumns]="true"
                 [columnResizeMode]="'expand'"
                 [styleClass]="'p-datatable-gridlines'"
                 [scrollable]="true"
                 [autoLayout]="true"
                 [loading]="loading"
                 [scrollHeight]="'flex'">
            <ng-template pTemplate="caption">
                <div class="card-progress-bar-head">
                    <div style="float: left;">
                        <h2>{{ getMenuHomeName() }}</h2>
                    </div>
                    <div class="flex flex-row finance-head-right">
                        <div class="ml-2 mr-2 mt-2">
                            <column-selector #columnSelector
                                 [defaultColumns]="cols"
                                 (selectedColumnsChange)="onSelectedColumnsChange($event)"
                                 [tableName]="tableName"
                                 [(selectedColumns)]="selectedColumns">
                            </column-selector>
                        </div>
                    </div>
                </div>
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <th *ngFor="let col of this.selectedColumns"
                        [pSortableColumn]="col.field"
                        pResizableColumn
                        [style.width]="col.width">
                        {{col.header}}
                        <p-sortIcon class="transactions-column-sorticon" [field]="col.field"></p-sortIcon>
                    </th>
                </tr>
                <tr>
                    <ng-container *ngFor="let filter of this.selectedColumns">
                        <th class="overflow-unset">
                            <ng-container *ngIf="filter.fieldType === fieldTypeEnum.Inputs">
                                <input type="text" pInputText placeholder="{{filter.placeholder}}" [(ngModel)]="txnHeaderSearch[filter.model]"
                                       (input)="handleFilterChange(filter.field, $event)" />
                            </ng-container>
                            <ng-container *ngIf="filter.fieldType === fieldTypeEnum.InputNumber">
                                <p-inputNumber inputId="integeronly" placeholder="{{filter.placeholder}}" [(ngModel)]="txnHeaderSearch[filter.model]"
                                               (ngModelChange)="handleFilterChange(filter.field, $event)"> </p-inputNumber>
                            </ng-container>
                            <ng-container *ngIf="filter.fieldType === fieldTypeEnum.Dropdown">
                                <ng-container *ngIf="filter.take === 'obj'; else dropdown">
                                    <p-dropdown [options]="filter.options" placeholder="{{filter.placeholder}}"
                                                optionLabel="name" [(ngModel)]="txnHeaderSearch[filter.model]"
                                                (ngModelChange)="onChangeHeaderFilterDropDown(filter.field, $event)"></p-dropdown>
                                </ng-container>
                                <ng-template #dropdown>
                                    <p-dropdown [options]="filter.options" placeholder="{{filter.placeholder}}"
                                                optionLabel="name" optionValue="value" [(ngModel)]="txnHeaderSearch[filter.model]"
                                                (ngModelChange)="onChangeHeaderFilterDropDown(filter.field, $event)"></p-dropdown>
                                </ng-template>
                            </ng-container>
                            <ng-container *ngIf="filter.fieldType === fieldTypeEnum.Calendar">
                                <p-calendar [(ngModel)]="txnHeaderSearch[filter.model]"
                                            [showIcon]="true"
                                            placeholder="{{filter.placeholder}}"
                                            dateFormat="dd M yy"
                                            (ngModelChange)="onChangeHeaderFilterDropDown(filter.field, $event)" />
                            </ng-container>
                            <ng-container *ngIf="filter.fieldType === fieldTypeEnum.CalendarTime">
                                <p-calendar [(ngModel)]="txnHeaderSearch[filter.model]"
                                            [timeOnly]="true"
                                            [showIcon]="true"
                                            hourFormat="12"
                                            placeholder="{{filter.placeholder}}"
                                            (ngModelChange)="onChangeHeaderFilterDropDown(filter.field, $event)" />
                            </ng-container>
                        </th>
                    </ng-container>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-transaction let-columns="columns">
                <tr>                    
                    <td *ngFor="let col of columns"
                        [pSelectableRow]="transaction"
                        (click)="handleShowTransactionInfo(transaction)">
                        <span *ngIf="col.action" 
                              class="onbg-status-col" 
                              [ngStyle]="col.action(transaction)">
                            {{ transaction[col.field] }}
                        </span>
                        <span *ngIf="!col.action">
                            {{ transaction[col.field] }}
                        </span>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="paginatorleft" let-state>
                <div *ngIf="paginator.Items.length > 0" style="padding-left: 10px">
                    Showing {{first + 1}} to {{first + paginator.Items.length}} of {{totalRecords}} entries
                </div>
            </ng-template>
        </p-table>
    </div>
</div>

<home-transaction-details *ngIf="showDetailTransactionSidebar"
                          [showTransactionsSidebar]="showDetailTransactionSidebar"
                          (updateTransactionsEmit)="updateEventEmit($event)"
                          [_transactionId]="selectedTransaction?.TransactionId">
</home-transaction-details>
